/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simpletoc_HeadingInputs */

const en_simpletoc_heading = /** @type {(inputs: Simpletoc_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table of contents`)
};

/**
* | output |
* | --- |
* | "Table of contents" |
*
* @param {Simpletoc_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const simpletoc_heading = /** @type {((inputs?: Simpletoc_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simpletoc_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_simpletoc_heading(inputs)
});